type NutakuEvent =
    | "nutaku-payment-created"
    | "nutaku-payment-complete"
    | "nutaku-payment-cancel"
    | "nutaku-payment-error"

type Callback = (payload: any) => void

const listeners: Record<string, Callback[]> = {}

export function onNutakuEvent(event: NutakuEvent, cb: Callback) {

    if (!listeners[event]) {
        listeners[event] = []
    }

    listeners[event].push(cb)
}

function emit(event: NutakuEvent, payload: any) {

    if (!listeners[event]) return

    listeners[event].forEach(cb => cb(payload))
}

;(window as any).onNutakuNativeEvent = (data: any) => {

    const {event, payload} = data

    emit(event, payload)
}